<nav class="navbar navbar-expand-lg bg-primary">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="">
      <img src="/images/addcar-logo-white.png" alt="addCar" height="64" />
    </a>
    <button class="navbar-toggler border-3" (click)="open(content)">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- desktop menu -->
    <div class="d-none d-lg-flex flex-fill justify-content-between">
      <ul class="navbar-nav gap-1">
        <!-- <li class="nav-item">
          <a
            class="nav-link fw-semibold"
            routerLink=""
            routerLinkActive="active bg-red-400 rounded"
            [routerLinkActiveOptions]="{ exact: true }">
            Home
          </a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link fw-semibold" routerLink="/operations" routerLinkActive="active bg-red-400 rounded">
            Operations
          </a>
        </li>
      </ul>
      <div class="d-flex gap-1">
        <div class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link fw-semibold" routerLink="">Welcome, {{ userName }}</a>
          </li>
        </div>
        <ul class="navbar-nav"></ul>
        <button class="btn btn-sm btn-light" (click)="logout()">Log out</button>
      </div>
    </div>
    <ng-template #content let-offcanvas>
      <div class="offcanvas-header">
        <h5 class="offcanvas-title">addCar Reservation System Module</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss()"></button>
      </div>
      <div class="offcanvas-body">
        <!-- tablet / mobile menu -->
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              class="nav-link fw-semibold px-3"
              routerLink=""
              routerLinkActive="active bg-red-400 rounded"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="offcanvas.dismiss()">
              Home
            </a>
          </li>
          <li>
            <hr />
          </li>
          <li class="nav-item">
            <a
              class="nav-link fw-semibold px-3"
              routerLink="/operations"
              routerLinkActive="active bg-red-400 rounded"
              (click)="offcanvas.dismiss()">
              Operation Management
            </a>
          </li>
          <li>
            <hr />
          </li>
          <li>
            <div class="d-flex flex-wrap">
              <div class="nav-item col-6">
                <a
                  class="nav-link fw-semibold px-3"
                  routerLink="/operations/reservations"
                  routerLinkActive="active bg-red-400 rounded"
                  (click)="offcanvas.dismiss()">
                  Reservations
                </a>
              </div>
              <div class="nav-item col-6">
                <a
                  class="nav-link fw-semibold px-3"
                  routerLink="/operations/rental-agreements"
                  routerLinkActive="active bg-red-400 rounded"
                  (click)="offcanvas.dismiss()">
                  Rental Agreements
                </a>
              </div>
            </div>
          </li>
        </ul>
        <hr />
        <div class="d-flex flex-column justify-content-center align-items-center gap-1">
          <div class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link fw-semibold px-3" routerLink="" (click)="offcanvas.dismiss()">
                Welcome, {{ userName }}
              </a>
            </li>
          </div>
          <ul class="navbar-nav"></ul>
          <button class="btn btn-light" (click)="logout()">Log out</button>
        </div>
        <hr />
        @if (version) {
          <div class="d-flex gap-2 justify-content-center align-items-center small" [title]="commit">
            Build {{ version }}
          </div>
        }
        <div class="d-flex gap-2 justify-content-center align-items-center small">
          <div>Powered by</div>
          <div>
            <img src="/images/stantum-logo.png" width="20" height="20" alt="Stantum" />
          </div>
          <div>
            <a class="text-white" href="https://stantum.eu/">Stantum s.r.o</a>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</nav>
